export default {
    contentTitle: {
        guide: 'แนะนำกิจกรรม',
        guideTooltip: 'กิจกรรมคืออะไร?',
    },
    modulePageTooltip: {
        tooltip: 'ทำไปด้วยกันจะยิ่งดีนะ!',
    },
    questionAccuracy: {
        realtime: 'เรียลไทม์',
        perQuestion: 'แยกตามข้อ',
    },
};
